export default class BasicCallCenterResponse {
  status!: number;

  message!: string;

  data!: unknown;
}
